/** Returns a normalized http(s) URL, or null if missing or unsafe (e.g. javascript:). */
export function toSafeHttpUrl(raw?: string | null): string | null {
  const value = raw?.trim();
  if (!value) {
    return null;
  }
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
      ? parsed.toString()
      : null;
  } catch {
    return null;
  }
}
